import { RequisitionStatus } from "../../enums/requisition-status-enum";
import { BaseModel } from "../base.model";
import { TemplateDocumentType } from "../document/document-template-model";
import { UserBaseModel } from "../members/user/user-base.model";

export type RequisitionStatusType = RequisitionStatus | undefined;

export class RequisitionBaseModel  extends BaseModel {
    number: string = "";
    status?: RequisitionStatus;
    type?: TemplateDocumentType|string;
    incidentDate: string = "";
    price:number = 0;
    processingFee:number = 0;
    additionalFee:number = 0;
    note?:string ;
    imageUrl?:string;
    dateOfLoss : string = "";
    matterNumber: string = "";
    reminderBackgroundJobId: string = "";
    rejectReason?: string;
    rejectDate?: string ;
    processedById?: string;
    processedDate?: string ;
    completedById?: string ;
    completedDate?: string ;
    submittedById?: string;
    submittedDate?: string ;
    incompletedById?: string ;
    incompletedDate?: string;
    clientId: string = "";
    accountId: string = "";
    totalInWords: string = "";
    totalCentsPart: string = "";
    total: number = 0;   
    isExplicitClientSignatureRequired?: boolean = false;
    requiresInvoiceApproval: boolean = false;
    assignees?: UserBaseModel[]|undefined;
    assigneeIds?: string[]|undefined;
    //used for displaying photo in list profiles 
    listPhoto?: any;
}
